import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16;
`;
